import AdaptiveUpgradeButton from 'components/account-features/AdaptiveUpgradeButton';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  contactAccountManagerWithUpgradeRequest,
  contactWorkspaceAdminWithUpgradeRequest,
} from 'redux/modules/subscriptions.actions';
import { clearMessageKey } from 'redux/modules/subscriptions.types';
import { getTimelineSubscriptionPrompt } from 'redux/selectors/timeline';
import type { ThunkDispatch } from 'types/redux';
import styles from './MemoryTimelineSubscriptionPrompt.module.scss';

type Props = {};

const MemoryTimelineSubscriptionPrompt: React.FC<Props> = () => {
  const { copy, upgradePermissions, messageKey } = useSelector(getTimelineSubscriptionPrompt);
  const dispatch = useDispatch<ThunkDispatch>();

  const handleCancel = useCallback(() => dispatch(clearMessageKey()), [dispatch]);

  const handleContactSupport = useCallback(() => {
    if (messageKey) {
      dispatch(contactAccountManagerWithUpgradeRequest(messageKey));
    }
  }, [messageKey, dispatch]);

  const handleContactWorkspaceOwner = useCallback(() => {
    if (messageKey) {
      dispatch(contactWorkspaceAdminWithUpgradeRequest(messageKey));
    }
  }, [messageKey, dispatch]);

  if (copy == null) {
    return null;
  }

  const { block1, block2, block3, ctaText } = copy;

  return (
    <section className={styles.container}>
      <div>
        {block1 && <p>{block1}</p>}
        {block2 && <p>{block2}</p>}
        {block3 && <p>{block3}</p>}
        <AdaptiveUpgradeButton
          upgradeText={ctaText || 'Select your plan now'}
          featureTrackingKey={messageKey}
          upgradePermissionsInfo={upgradePermissions}
          onContactSupport={handleContactSupport}
          onContactWorkspaceOwner={handleContactWorkspaceOwner}
          onDismiss={handleCancel}
          hideGotIt
        />
        <span>
          You always own your memories.{' '}
          <a
            href="https://support.timelyapp.com/en/articles/4380382-managing-your-timely-profile"
            target="_blank"
            rel="noopener"
          >
            Learn more
          </a>
        </span>
      </div>
    </section>
  );
};

export default MemoryTimelineSubscriptionPrompt;
